import React from 'react';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';

type ExecuteRecaptcha = (action: string) => Promise<string>;

export function withGoogleReCaptcha<P extends object>(
  WrappedComponent: React.ComponentType<P & { executeRecaptcha: ExecuteRecaptcha }>
): React.FC<P> {
  const HOC: React.FC<P> = (props) => {
    const recaptcha = useGoogleReCaptcha();

    if (!recaptcha || !recaptcha.executeRecaptcha) {
      return null;
    }

    return (
      <WrappedComponent
        {...props}
        executeRecaptcha={recaptcha.executeRecaptcha}
      />
    );
  };

  return HOC;
}
